<script lang="ts">
  interface Props {
    value?: string;
    isBold?: boolean;
  }

  let { value = '', isBold = true }: Props = $props();
</script>

<div class="simple-text">
  {#if value}
    <div class="text" class:bold={isBold}>{value}</div>
  {:else}
    <div class="warn">No value</div>
  {/if}
</div>

<style>
  .simple-text {
    align-items: flex-start;
    padding: 12px 16px;
  }
  .simple-text .bold {
    color: var(--black);
    font-weight: 500;
  }
</style>
